import {View, StyleSheet} from 'react-native';
import Text from '@/components/basic/text';
import React from 'react';
import theme from '@/style';
import {useTranslation} from 'react-i18next';
import {currentBrand} from '@/brands';

export interface TableHeaderProps {
  headers: string[];
}

const TableHeader = ({headers = []}: TableHeaderProps) => {
  const {i18n} = useTranslation();
  const isAnna = currentBrand.key === 'anna';

  const resolveLabel = React.useCallback(
    (key: string) => {
      if (isAnna) {
        const annaMap: Record<string, string> = {
          perriod: 'PERRIOD',
          number: 'NUMBER',
        };
        return annaMap[key] || key;
      }
      return i18n.t(`game-page.label.${key}`).toUpperCase();
    },
    [i18n, isAnna],
  );

  return (
    <View style={[theme.margin.lrl, styles.wrap]}>
      <View style={styles.issueCol}>
        <Text color={theme.fontColor.second} style={styles.text}>
          {resolveLabel(headers[0] || '').toUpperCase()}
        </Text>
      </View>
      <View style={styles.numberCol}>
        <Text
          color={theme.fontColor.second}
          style={[styles.text, styles.rightText]}>
          {resolveLabel(headers[1] || '').toUpperCase()}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#E9ECF5',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  issueCol: {
    flex: 1,
  },
  numberCol: {
    flex: 2,
    alignItems: 'flex-end',
  },
  text: {
    fontSize: 11,
    fontWeight: '500',
    color: '#7F8896',
    letterSpacing: 0.2,
  },
  rightText: {
    textAlign: 'right',
  },
});

export default TableHeader;
